import { ReactElement } from 'react'

import LogoHorizontalWhite from '@shared/assets/images/logo-horizontal-white.svg'
import LogoHorizontal from '@shared/assets/images/logo-horizontal.svg'
import { useTheme } from '@shared/components/Theme/hooks/useTheme'

import { SidebarDesktopCurrentUser } from './SidebarDesktopCurrentUser'
import { SidebarDesktopDarkMode } from './SidebarDesktopDarkMode'
import { SidebarDesktopListItems } from './SidebarDesktopListItems'

export const SidebarDesktop = (): ReactElement => {
  const { theme } = useTheme()

  const Logo = theme === 'dark' ? LogoHorizontalWhite : LogoHorizontal

  return (
    <aside className="border-text-secondary/15 dark:bg-background-secondary fixed hidden h-full min-w-64 flex-col rounded-r-xl border-r bg-white py-8 shadow-lg lg:flex dark:border-white/10">
      <img src={Logo} alt="BrazaLink" className="mx-auto mb-10 h-auto w-44" />

      <SidebarDesktopListItems />

      <section className="bg-background-secondary mt-auto flex flex-col border-t border-white/30 pt-8 shadow-inner dark:border-white/5">
        <SidebarDesktopCurrentUser />
        <SidebarDesktopDarkMode />
      </section>
    </aside>
  )
}
